module.exports = __webpack_public_path__ + "fonts/fa-solid-900.b5596f4.eot";